import { render } from "./TooltipError.vue?vue&type=template&id=6f9024e5"
import script from "./script/index?vue&type=script&lang=js&external"
export * from "./script/index?vue&type=script&lang=js&external"

import "./TooltipError.vue?vue&type=style&index=0&id=6f9024e5&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__